import { useState } from 'react';

import { useKey } from 'react-use';

interface Return {
  open: boolean;
  openSidebar(): void;
  closeSidebar(): void;
}

export const useResponsiveSidebar = (): Return => {
  const [open, setOpen] = useState(false);

  const openSidebar = () => {
    setOpen(true);
  };

  const closeSidebar = () => {
    setOpen(false);
  };

  useKey(
    event => open && (event.key === 'Escape' || event.key === 'Esc'),
    closeSidebar,
  );

  return {
    open,
    openSidebar,
    closeSidebar,
  };
};
